import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/dashboard`;
    }

    public getAdminChartInformations(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-charts-informations`);
    }

    public getDetailCustomerChartInformations(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-customer-details`);
    }

    public getDetailScanChartInformations(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-scan-details`);
    }

    public getCategoryByScanChartInfo(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-scan-by-categories`);
    }

    public getOfferByScanChartInfo(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-scan-by-offers`);
    }

    public getPartnersByScanChartInfo(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-scan-by-partners`);
    }

    public getChartInformation(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/charts-information`);
    }

    public getSubscribedCountPerSexeBetweenDates(selectedYear: any, selectedDates: string[], ages: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-subscribed-by-sex?year=${selectedYear}&dates=${selectedDates}&ages=${ages}&zipCode=${selectedZipCode}`);
    }

    public getRegisteredCountPerSexBetweenDates(selectedYear: any, selectedDates: string[], ages: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-registered-by-sex?year=${selectedYear}&dates=${selectedDates}&ages=${ages}&zipCode=${selectedZipCode}`);
    }

    public getSubscribedVersusRegisteredClientsCountBetweenDates(selectedYear: any, selectedDates: string[], ages: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-subscribed-vs-registered?year=${selectedYear}&dates=${selectedDates}&ages=${ages}&zipCode=${selectedZipCode}`);
    }

    public getScanCountPerSexeBetweenDates(selectedYear: any, selectedDates: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-scans-by-sex?year=${selectedYear}&dates=${selectedDates}&zipCode=${selectedZipCode}`);
    }

    public getPartnersChart(selectedYear: any, monthly: boolean, ages: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-partners-chart?year=${selectedYear}&monthly=${monthly}&ages=${ages}&zipCode=${selectedZipCode}`);
    }

    public getCAChart(selectedYear: any, selectedDates: string[], selectedZipCode: any): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/admin-ca-chart?year=${selectedYear}&dates=${selectedDates}&zipCode=${selectedZipCode}`);
    }

}
